/* eslint-disable camelcase */
import { getAges } from 'api/ages.api';
import { getEthnicities } from 'api/ethnicities.api';
import { getGenders } from 'api/genders.api';
import { getRoles } from 'api/roles.api';
import { getUserByUid } from 'api/users.api';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetInvestorProfileData = async () => {
  $form.reset({});
  $view.update({
    isLoading: true,
    error: null,
  });
  try {
    const [{ data: ages }, { data: genders }, { data: ethnicities }, { data: investorRoles }, userData] = await Promise.all([
      getAges(),
      getGenders(),
      getEthnicities(),
      getRoles({ userType: $user.value.userType }),
      getUserByUid($user.value.uid),
    ]);

    const ageOptions = ages?.map(ageItem => ({ id: ageItem.id, value: ageItem.id, label: ageItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label));
    const genderOptions = genders?.map(genderItem => ({ id: genderItem.id, value: genderItem.id, label: genderItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label));
    const ethnicityOptions = ethnicities?.map(ethnicityItem => ({ id: ethnicityItem.id, value: ethnicityItem.id, label: ethnicityItem.description }))
      .sort((a, b) => a.label.localeCompare(b.label));

    const { roles } = investorRoles || {};

    const roleOptions = roles?.map(role => ({
      value: role.id,
      label: role.name,
    })) || [];

    // Find matching option objects for select fields
    const ageOption = ageOptions?.find(option => option.value === userData.ageId);
    const genderOption = genderOptions?.find(option => option.value === userData.genderId);
    const ethnicityOption = ethnicityOptions?.find(option => option.value === userData.ethnicityId);

    $form.update({
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      profileImage: userData.profileImage,
      avatarColors: userData.avatarColors,
      logoImage: userData.logo,
      roles: userData.roles || [],
      age: ageOption || null,
      gender: genderOption || null,
      ethnicity: ethnicityOption || null,
      otherConditions: userData.otherConditions || [],
      organizationName: userData.organization?.name,
      organizationEmail: userData.organization?.email,
      organizationWebsite: userData.organization?.website,
      organizationLogo: userData.organization?.logo,
      organizationLogoColors: userData.organization?.logoColors,
      investmentStages: userData.organization?.investmentStages || [],
      newInvestmentStages: userData.organization?.investmentStages || [],
      levelOfEducation: userData.levelOfEducation || '',
      undergraduateUniversity: userData.undergraduateUniversity || '',
      graduateUniversity: userData.graduateUniversity || '',
    });

    $view.update({
      roleOptions: roleOptions || [],
      ageOptions: ageOptions || [],
      genderOptions: genderOptions || [],
      ethnicityOptions: ethnicityOptions || [],
      firstName: $user.value.firstName,
      lastName: $user.value.lastName,
      email: $user.value.email,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load profile data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};
